<template>
  <div data-view="download-invoice">
    <component :is="componentName" :has-aside="false">
      <template v-slot:content>
        {{ '' }}
      </template>
    </component>
  </div>
</template>

<script>
  export default {
    computed: {
      isLogged() {
        return this.$store.getters['auth/isLogged'];
      },
      componentName() {
        return this.isLogged ? 'layout-logged-frame' : 'layout-auth-frame';
      },
    },
    created() {
      this.downloadInvoice();
    },
    methods: {
      downloadInvoice() {
        const { token, source } = this.$route.params;
        const query = {
          token,
          source,
        };

        return this.$store
          .dispatch('invoices/downloadPublicInvoice', query)
          .finally(this.goToHome);
      },
      goToHome() {
        return this.$router.push('/');
      },
    },
  };
</script>
